import { ReceiptDetailPanelVariant } from "./shared/ReceiptDetailPanelVariant";
import ecoSign from "./images/ecoSign.png";
import { receiptDetailExamples } from "./ReceiptDetailExamples";

export const ReceiptDetailPanel = () => (
  <ReceiptDetailPanelVariant
    examples={receiptDetailExamples}
    imageFolder="productImages"
    badgeIcon={ecoSign}
    badgeAlt="Bio-zertifiziert"
    badgeTitle="Bio-zertifiziert"
    labelColMd={6}
  />
);
